import type { SectionLocale } from '../types'

export const BASE_LOCALE: SectionLocale = [
  [
    'base_yes',
    {
      ru: 'Да',
      en: 'Yes',
    },
  ],
  [
    'base_confirm',
    {
      ru: 'Подтвердить',
      en: 'Confirm',
    },
  ],
  [
    'base_no',
    {
      ru: 'Нет',
      en: 'No',
    },
  ],
  [
    'base_delete',
    {
      ru: 'Удалить',
      en: 'Delete',
    },
  ],
  [
    'base_leave_items',
    {
      ru: 'Оставить',
      en: 'Leave',
    },
  ],
  [
    'base_cancel_item_editing',
    {
      ru: 'Есть несохраненные изменения. Сохранить?',
      en: 'There are unsaved changes. Save?',
    },
  ],
  [
    'base_unsaved_changes_title',
    {
      ru: 'Несохраненные изменения',
      en: 'Unsaved changes',
    },
  ],
  [
    'base_unsaved_changes_message',
    {
      ru: 'Есть несохраненные изменения. Сохранить перед тем как продолжить?',
      en: 'There are unsaved changes. Save before continuing?',
    },
  ],
  [
    'base_unsaved_changes_discard',
    {
      ru: 'Не сохранять',
      en: "Don't save",
    },
  ],
  [
    'base_unsaved_changes_save',
    {
      ru: 'Сохранить изменения',
      en: 'Save changes',
    },
  ],
  [
    'base_sort',
    {
      ru: 'Сортировать',
      en: 'Sort',
    },
  ],
  [
    'base_categories',
    {
      ru: 'Категории',
      en: 'Categories',
    },
  ],
  [
    'base_apply',
    {
      ru: 'Применить',
      en: 'Apply',
    },
  ],
  [
    'base_show-more',
    {
      ru: 'Показать еще',
      en: 'Show more',
    },
  ],
  [
    'base_sort_by_default',
    {
      ru: 'По умолчанию',
      en: 'Default',
    },
  ],
  [
    'base_sort_by_name',
    {
      ru: 'Название',
      en: 'Name',
    },
  ],
  [
    'base_sort_by_price',
    {
      ru: 'Цена',
      en: 'Price',
    },
  ],
  [
    'base_sort_by_price_asc',
    {
      ru: 'Сначала дешевые',
      en: 'From cheaper',
    },
  ],
  [
    'base_sort_by_price_desc',
    {
      ru: 'Сначала дорогие',
      en: 'From expensive',
    },
  ],
  [
    'base_sort_by_popularity',
    {
      ru: 'Популярность',
      en: 'Popularity',
    },
  ],
  [
    'base_balance',
    {
      ru: 'Баланс',
      en: 'Balance',
    },
  ],
  [
    'balance_history_empty',
    {
      ru: 'История пуста',
      en: 'History is empty',
    },
  ],
  [
    'balance_default',
    {
      ru: 'Баланс кошелька',
      en: 'Wallet balance',
    },
  ],
  [
    'balance_active_coins',
    {
      ru: 'Монеты для передачи',
      en: 'Coins for transfer',
    },
  ],
  [
    'balance_active',
    {
      ru: 'Баланс для передачи',
      en: 'Active balance',
    },
  ],
  [
    'base_save',
    {
      ru: 'Сохранить',
      en: 'Save',
    },
  ],
  [
    'base_add',
    {
      ru: 'Добавить',
      en: 'Add',
    },
  ],
  [
    'base_send',
    {
      ru: 'Отправить',
      en: 'Send',
    },
  ],
  [
    'base_cancel',
    {
      ru: 'Отменить',
      en: 'Cancel',
    },
  ],
  [
    'base_close',
    {
      ru: 'Закрыть',
      en: 'Close',
    },
  ],
  [
    'base_reset',
    {
      ru: 'Сброс',
      en: 'Reset',
    },
  ],
  [
    'base_photos',
    {
      ru: 'Фотографии',
      en: 'Photos',
    },
  ],
  [
    'base_incorrect_data',
    {
      ru: 'Некорректные данные',
      en: 'Incorrect data',
    },
  ],
  [
    'base_min_length_chars',
    {
      ru: 'Минимум {n} символ | Минимум {n} символа | Минимум {n} символов',
      en: 'Minimum {n} character | Minimum {n} characters',
    },
  ],
  [
    'base_max_length_chars',
    {
      ru: 'Максимум {n} символ | Максимум {n} символа | Максимум {n} символов',
      en: 'Maximum {n} character | Maximum {n} characters',
    },
  ],
  [
    'base_required_field',
    {
      ru: 'Это обязательное поле',
      en: 'This field is required',
    },
  ],

  [
    'base_incorrect_email',
    {
      ru: 'Некорректный email',
      en: 'Incorrect email',
    },
  ],
  [
    'base_incorrect_phone',
    {
      ru: 'Некорректный номер телефона',
      en: 'Invalid phone number',
    },
  ],
  [
    'base_latin_only_characters',
    {
      ru: 'Допустимы только латиница, цифры и знаки препинания',
      en: 'Only Latin characters, digits and punctuation are allowed',
    },
  ],
  [
    'base_country',
    {
      ru: 'Страна',
      en: 'Country',
    },
  ],
  [
    'base_city',
    {
      ru: 'Город',
      en: 'City',
    },
  ],
  [
    'base_address',
    {
      ru: 'Адрес',
      en: 'Address',
    },
  ],
  [
    'base_postal_code',
    {
      ru: 'Индекс',
      en: 'Zip code',
    },
  ],
  [
    'base_phone',
    {
      ru: 'Телефон',
      en: 'Phone',
    },
  ],
  [
    'base_email',
    {
      ru: 'Email',
      en: 'Email',
    },
  ],
  [
    'base_something_went_wrong',
    {
      ru: 'Что-то пошло не так',
      en: 'Something went wrong',
    },
  ],
  [
    'base_search',
    {
      ru: 'Поиск',
      en: 'Search',
    },
  ],
  [
    'max_img_size_text_5mb',
    {
      ru: 'Размер одного изображения не должен превышать 5 МБ',
      en: 'The size of one image should not exceed 5 MB',
    },
  ],
  [
    'upload_imgs',
    {
      ru: 'Загрузить изображения',
      en: 'Upload images',
    },
  ],
  [
    'base_signout',
    {
      ru: 'Выйти из профиля',
      en: 'Sign out',
    },
  ],
  [
    'base_dragndrop_description',
    {
      ru: `<span class="font-bold underline">Выберите</span> файл <br /> или перетащите его в эту область`,
      en: `<span class="font-bold underline">Select</span> a file <br /> or drop it onto this field`,
    },
  ],
  [
    'base_task_link',
    {
      ru: 'Ссылка на задачу',
      en: 'Link to task',
    },
  ],
  [
    'base_aria_language_switcher',
    {
      ru: 'Выбрать язык, текущий: {language}',
      en: 'Select language, current: {language}',
    },
  ],
  [
    'base_date_start',
    {
      ru: 'Дата начала',
      en: 'Start date',
    },
  ],
  [
    'base_date_end',
    {
      ru: 'Дата окончания',
      en: 'End date',
    },
  ],
  [
    'base_select_users',
    {
      ru: 'Выбрать пользователей',
      en: 'Select users',
    },
  ],
  [
    'base_remove_user',
    {
      ru: 'Удалить пользователя {name}',
      en: 'Remove user {name}',
    },
  ],
  [
    'base_clear_list',
    {
      ru: 'Очистить список',
      en: 'Clear the list',
    },
  ],
  [
    'base_choose_file',
    {
      ru: 'Выберите файл',
      en: 'Choose a file',
    },
  ],
  [
    'base_processing',
    {
      ru: 'Обрабатывается...',
      en: 'Processing...',
    },
  ],
  [
    'base_copied_successfully',
    {
      ru: 'Скопировано',
      en: 'Copied',
    },
  ],
  // Панель форматирования текстового редактора (aria-подписи кнопок)
  [
    'editor_toolbar_heading',
    {
      ru: 'Заголовок',
      en: 'Heading',
    },
  ],
  [
    'editor_toolbar_font_size',
    {
      ru: 'Размер шрифта',
      en: 'Font size',
    },
  ],
  [
    'editor_toolbar_text_color',
    {
      ru: 'Цвет текста',
      en: 'Text color',
    },
  ],
  [
    'editor_toolbar_bold',
    {
      ru: 'Жирный',
      en: 'Bold',
    },
  ],
  [
    'editor_toolbar_italic',
    {
      ru: 'Курсив',
      en: 'Italic',
    },
  ],
  [
    'editor_toolbar_underline',
    {
      ru: 'Подчёркнутый',
      en: 'Underline',
    },
  ],
  [
    'editor_toolbar_link',
    {
      ru: 'Ссылка',
      en: 'Link',
    },
  ],
  [
    'editor_toolbar_align_left',
    {
      ru: 'По левому краю',
      en: 'Align left',
    },
  ],
  [
    'editor_toolbar_align_center',
    {
      ru: 'По центру',
      en: 'Align center',
    },
  ],
  [
    'editor_toolbar_align_right',
    {
      ru: 'По правому краю',
      en: 'Align right',
    },
  ],
  [
    'editor_toolbar_align_justify',
    {
      ru: 'По ширине',
      en: 'Align justify',
    },
  ],
  [
    'editor_toolbar_undo',
    {
      ru: 'Отменить',
      en: 'Undo',
    },
  ],
  [
    'editor_toolbar_redo',
    {
      ru: 'Повторить',
      en: 'Redo',
    },
  ],
]
